import React, { useState } from "react";
import { Tooltip, Skeleton } from "antd";
import { ICONS } from "assets/icons";
export default function VerticalNavSection({
  title,
  items = [],
  activeNav,
  handleItemClick,
  secondaryToggle,
  setSecondaryToggle,
  loading,
}) {
  const isSectionOpen = secondaryToggle?.[title.toLowerCase()] ?? true;
  const [isExpanded, setIsExpanded] = useState(false);

  const visibleItems =
    isExpanded || items.length <= 3 ? items : items.slice(0, 3);
  const shouldShowToggle = items.length > 3;

  const handleToggle = () => setIsExpanded((prev) => !prev);

  const toggleSection = () => {
    setSecondaryToggle((prev) => ({
      ...prev,
      [title.toLowerCase()]: !prev[title.toLowerCase()],
    }));
  };

  return (
    <div className="w-full py-2">
      <div
        className="flex items-center cursor-pointer select-none sidebar-header"
        onClick={toggleSection}
      >
        <img
          src={ICONS?.sidebarChevronDown}
          alt="Toggle"
          className={`w-3 h-4 mr-10 transition-transform duration-200 ${
            isSectionOpen ? "rotate-0" : "rotate-180"
          }`}
        />
        <span className="">{title}</span>
      </div>

      {isSectionOpen && (
        <div className="flex flex-col gap-1 mt-10">
          {loading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="px-3 py-2">
                <Skeleton.Input active size="small" style={{ width: "80%" }} />
              </div>
            ))
          ) : (
            <>
              {visibleItems?.map((item) => (
                <div
                  key={item?.key}
                  onClick={() => handleItemClick(item)}
                  className={`flex items-center justify-between gap-2 px-3 py-2 rounded-lg cursor-pointer mb-[5px] transition-colors 
                    ${
                      activeNav === item.name
                        ? "sidebar-sub-header-active pb-10"
                        : "sidebar-sub-header hover:bg-slate-100 pb-10"
                    }`}
                >
                  <div className="flex items-center gap-2">
                    <div className="text-lg">
                      {item?.display_color && (
                        <div
                          className="size-4 rounded-[4px]"
                          style={{
                            background:
                              item?.display_color ?? item?.display_color,
                          }}
                        />
                      )}
                      {item?.display_emoji && (
                        <span className="chart-headers">
                          {item?.display_emoji}
                        </span>
                      )}
                    </div>
                    <Tooltip title={item.name} placement="top">
                      <span className="truncate capitalize max-w-[120px] text-sm py-[2.8px]">
                        {item.name}
                      </span>
                    </Tooltip>
                  </div>
                  {item.cc_count !== undefined && (
                    <span className="bg-[#6940F2] text-[white] text-[0.65rem] font-[600] py-0.45 px-2 rounded-lg">
                      {item.cc_count}
                    </span>
                  )}
                </div>
              ))}

              {shouldShowToggle && (
                <div
                  onClick={handleToggle}
                  className="flex items-center font-normal justify-between gap-2 px-3 py-2 rounded-lg cursor-pointer hover:bg-slate-100 text-[8px] transition-colors"
                >
                  <div className="flex items-center gap-2">
                    <img
                      src={ICONS?.sidebarChevronDown}
                      alt="Toggle"
                      className={`w-[10px] h-[10px] mr-2 transition-transform duration-200 ${
                        isExpanded ? "rotate-180" : "rotate-0"
                      }`}
                    />
                    <span className="text-xs font-[12px]">{isExpanded ? "See Less" : "See More"}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
